import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'
import { useCartStore } from '../store/index'
import { supabase } from '../lib/supabaseClient'
import { getCompanySettings } from '../lib/companySettings'
import PublicChatWidget from './PublicChatWidget'

const Header = () => {
  const { user, profile, signOut } = useAuthStore()
  const { items } = useCartStore()

  const handleSignOut = async () => {
    try {
      // Clear local state immediately
      localStorage.clear()
      sessionStorage.clear()
      
      // Try Supabase sign out
      await signOut()
      
      // Force redirect to home
      window.location.href = '/'
    } catch (error) {
      console.warn('Sign out error:', error)
      // Clear everything and redirect anyway
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = '/'
    }
  }

  const cartItemsCount = items.reduce((total, item) => total + item.quantity, 0)
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      const data = await getCompanySettings(supabase)
      if (mounted) setSettings(data)
    })()
    return () => { mounted = false }
  }, [])

  return (
    <>
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              {settings?.logo_url ? (
                <img src={settings.logo_url} alt={settings?.website_name || 'Logo'} className="h-8 w-8 rounded-lg object-cover" />
              ) : (
                <div className="h-8 w-8 bg-primary-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-lg">{(settings?.website_name || 'OM').slice(0,2)}</span>
                </div>
              )}
              <span className="ml-2 text-xl font-bold text-gray-900">{settings?.website_name || 'One Matrix'}</span>
            </Link>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              Home
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              Services
            </Link>
            <Link to="/products" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              Products
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
              Contact
            </Link>
          </nav>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            {/* Cart Icon */}
            <Link to="/cart" className="relative p-2 text-gray-700 hover:text-primary-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
              </svg>
              {cartItemsCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartItemsCount}
                </span>
              )}
            </Link>

            {user ? (
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-700">
                  Welcome, {profile?.name || user?.user_metadata?.name || user?.email}
                </span>
                
                {/* Dashboard Link - Always show for logged in users */}
                <Link 
                  to={profile?.role === 'admin' ? '/admin' : 
                      profile?.role === 'employee' ? '/employee' : '/client'} 
                  className="btn-primary text-sm"
                >
                  Dashboard
                </Link>
                
                <button
                  onClick={handleSignOut}
                  className="text-gray-700 hover:text-primary-600 text-sm font-medium"
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login" className="text-gray-700 hover:text-primary-600 text-sm font-medium">
                  Sign In
                </Link>
                <Link to="/signup" className="btn-primary text-sm">
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
    <PublicChatWidget />
    </>
  )
}

export default Header
